import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import PageNavigation from './components/PageNavigation';
import Overview from './pages/Overview';
import Portfolio from './pages/Portfolio';
import Transactions from './pages/Transactions';
import TopBuyers from './pages/TopBuyers';
import Login from './pages/Login';
import ChangePassword from './pages/ChangePassword';
import Logout from './pages/Logout';
import { mockUserData, getMenuItemsForPage, getHeaderData } from './data/mockData';
import { isAuthenticated, getTokens, getApiBaseUrl, setApiBaseUrl } from './utils/auth';
import './App.css';

const AppContent: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [headerData, setHeaderData] = useState(getHeaderData());
  const [apiBaseUrl, setApiBaseUrlState] = useState<string>(getApiBaseUrl());

  const handleNavigate = (path: string) => {
    navigate(path);
  };

  const handleTabChange = (tabLabel: string) => {
    // Handle monitor/planning tab changes
    const updatedTabs = headerData.monitorPlanningTabs.map(tab => ({
      ...tab,
      active: tab.label === tabLabel
    }));
    
    setHeaderData({
      ...headerData,
      monitorPlanningTabs: updatedTabs
    });
  };
  const handleEditApiBaseUrl = (next: string) => {
    setApiBaseUrl(next);
    setApiBaseUrlState(getApiBaseUrl());
  };


  const currentPath = location.pathname;
  const menuItems = getMenuItemsForPage(currentPath);
  const pageNavItems = getMenuItemsForPage(currentPath);

  // Listen for header subProject updates coming from API
  React.useEffect(() => {
    const onUpdate = (e: Event) => {
      const next = getHeaderData();
      setHeaderData(h => ({ ...h, subProject: next.subProject }));
    };
    window.addEventListener('header:subproject', onUpdate as EventListener);
    return () => window.removeEventListener('header:subproject', onUpdate as EventListener);
  }, []);

  const authed = isAuthenticated();

  const { userName } = getTokens();

  return (
    <div className="app">
      {authed && (
        <Sidebar 
          menuItems={menuItems}
          username={userName || mockUserData.username}
          onNavigate={handleNavigate}
        />
      )}
      
      <div className="main-content">
        {authed && (
          <Header
            projectName={headerData.projectName}
            subProject={headerData.subProject}
            monitorPlanningTabs={headerData.monitorPlanningTabs}
            onTabChange={handleTabChange}
            apiBaseUrl={apiBaseUrl}
            onEditApiBaseUrl={handleEditApiBaseUrl}
          />
        )}
        
        {authed && (
          <PageNavigation
            items={pageNavItems}
            onNavigate={handleNavigate}
          />
        )}
        
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={authed ? <Overview /> : <Login />} />
          <Route path="/overview" element={authed ? <Overview /> : <Login />} />
          {/* Temporarily hide portfolio: route falls back to Overview */}
          <Route path="/portfolio" element={authed ? <Overview /> : <Login />} />
          <Route path="/transactions" element={authed ? <Transactions /> : <Login />} />
          <Route path="/buyers" element={authed ? <TopBuyers /> : <Login />} />
          <Route path="/change-password" element={authed ? <ChangePassword /> : <Login />} />
          <Route path="/logout" element={<Logout />} />
        </Routes>
      </div>
    </div>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;
